// USPS sectional-center allocation: inclusive 3-digit zip prefix ranges per
// state. Compact range form instead of ~900 individual prefixes; gaps are
// unassigned prefixes or military/territory codes we do not serve.
type ZipRange = { end: number; start: number; stateCode: string };

const ZIP_PREFIX_RANGES: ZipRange[] = [
  { end: 5, start: 5, stateCode: 'NY' },
  { end: 9, start: 6, stateCode: 'PR' },
  { end: 27, start: 10, stateCode: 'MA' },
  { end: 29, start: 28, stateCode: 'RI' },
  { end: 38, start: 30, stateCode: 'NH' },
  { end: 49, start: 39, stateCode: 'ME' },
  { end: 59, start: 50, stateCode: 'VT' },
  { end: 69, start: 60, stateCode: 'CT' },
  { end: 89, start: 70, stateCode: 'NJ' },
  { end: 149, start: 100, stateCode: 'NY' },
  { end: 196, start: 150, stateCode: 'PA' },
  { end: 199, start: 197, stateCode: 'DE' },
  { end: 200, start: 200, stateCode: 'DC' },
  { end: 201, start: 201, stateCode: 'VA' },
  { end: 205, start: 202, stateCode: 'DC' },
  { end: 219, start: 206, stateCode: 'MD' },
  { end: 246, start: 220, stateCode: 'VA' },
  { end: 268, start: 247, stateCode: 'WV' },
  { end: 289, start: 270, stateCode: 'NC' },
  { end: 299, start: 290, stateCode: 'SC' },
  { end: 319, start: 300, stateCode: 'GA' },
  { end: 339, start: 320, stateCode: 'FL' },
  { end: 342, start: 341, stateCode: 'FL' },
  { end: 349, start: 344, stateCode: 'FL' },
  { end: 369, start: 350, stateCode: 'AL' },
  { end: 385, start: 370, stateCode: 'TN' },
  { end: 397, start: 386, stateCode: 'MS' },
  { end: 399, start: 398, stateCode: 'GA' },
  { end: 427, start: 400, stateCode: 'KY' },
  { end: 459, start: 430, stateCode: 'OH' },
  { end: 479, start: 460, stateCode: 'IN' },
  { end: 499, start: 480, stateCode: 'MI' },
  { end: 528, start: 500, stateCode: 'IA' },
  { end: 549, start: 530, stateCode: 'WI' },
  { end: 567, start: 550, stateCode: 'MN' },
  { end: 577, start: 570, stateCode: 'SD' },
  { end: 588, start: 580, stateCode: 'ND' },
  { end: 599, start: 590, stateCode: 'MT' },
  { end: 629, start: 600, stateCode: 'IL' },
  { end: 658, start: 630, stateCode: 'MO' },
  { end: 679, start: 660, stateCode: 'KS' },
  { end: 693, start: 680, stateCode: 'NE' },
  { end: 714, start: 700, stateCode: 'LA' },
  { end: 729, start: 716, stateCode: 'AR' },
  { end: 749, start: 730, stateCode: 'OK' },
  { end: 799, start: 750, stateCode: 'TX' },
  { end: 816, start: 800, stateCode: 'CO' },
  { end: 831, start: 820, stateCode: 'WY' },
  { end: 838, start: 832, stateCode: 'ID' },
  { end: 847, start: 840, stateCode: 'UT' },
  { end: 865, start: 850, stateCode: 'AZ' },
  { end: 884, start: 870, stateCode: 'NM' },
  { end: 885, start: 885, stateCode: 'TX' },
  { end: 898, start: 889, stateCode: 'NV' },
  { end: 961, start: 900, stateCode: 'CA' },
  { end: 966, start: 962, stateCode: 'AP' },
  { end: 968, start: 967, stateCode: 'HI' },
  { end: 969, start: 969, stateCode: 'GU' },
  { end: 979, start: 970, stateCode: 'OR' },
  { end: 994, start: 980, stateCode: 'WA' },
  { end: 999, start: 995, stateCode: 'AK' },
];

export const zipToState = (zip: string): string | undefined => {
  if (!/^\d{5}$/.test(zip)) {
    return undefined;
  }

  const prefix = Number(zip.slice(0, 3));
  const match = ZIP_PREFIX_RANGES.find(({ end, start }) => prefix >= start && prefix <= end);

  return match?.stateCode;
};
